module.exports = __webpack_public_path__ + "img/car_icon.a1441176.png";